import { Component, OnInit } from '@angular/core';
import {TopicService} from '../../services/topic.service';
import {Topic} from '../topic/model/topic';
import {User} from './model/user';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {UserService} from '../../services/user.service';
import {Login} from '../../services/user.service';

@HostListener('window:keydown', ['$event'])
@Component({
	host: {
		//'(document:keyup)': 'keyDown($event)',
		'(document:keydown)': 'keyDown($event)',
	},
	selector: 'app-user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.css'],
})

export class UserComponent implements OnInit {
  public hex = require("../../../assets/hex.jpg");
	topics: Topic[];
	userss: User[];
	public model = new Topic('', '', '');
	public user = new User('', '', '');
	private umodel = new Topic('', '', '');
	public selectedTopic;
	selectedIndex = 0;
	message = "";
	searchText = "";
	currentPage = 0;
	pageSize = 10;
	pageDirection = -1;
	totalCount = 0;
	pageCount = 0;
	sortKey = "insertdate";
	selectAll = false;
	theUser: string;

	constructor(private topicService: TopicService, private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router) { }
	ngOnInit() { 

 		this.theUser = this.userSVC.loggedInUser.email;
 	if (!this.theUser) {
		this.router.navigate(['']);
	}

		this.activatedRoute.queryParams.subscribe(params => {
      this.model.hashTag = params['h'] || "";
       if(this.model.hashTag != "") {
           this.open();
       }
		});
	}

  open() {
      this.topicService.filterTopics(this.model.hashTag, "", "", "", this.theUser)
            .subscribe(
                topics => {
               this.topics = topics; //Bind to view
               if(this.topics !== undefined) {
                  this.model = this.topics[0];
               }
           },
           err => {
               console.log(err);
           });

      this.userSVC.getUserByEmail(this.theUser)
            .subscribe(
                user => {
                if (user) {
                   this.user = user; //Bind to view
               }
           },
           err => {
               console.log(err);
           });
  }

	loadTopics(callback: () => any) {
		if (this.searchText == "") {
		 this.topicService.filterTopics(this.model.hashTag, "", "", "", this.theUser)
				   .subscribe(
				       topics => {
							this.topics = topics; //Bind to view
							if(this.topics !== undefined) {
								this.totalCount = this.topics.length;
								this.pageCount = Math.ceil(this.totalCount / this.pageSize);
								callback();
								this.setPageVisible();
							}
					},
					err => {
					    console.log(err);
					});
		} else {
		 this.model = new Topic('', '', '');
		 this.topicService.searchTopics(this.searchText, this.sortKey, this.theUser)
				   .subscribe(
				       topics => {
							this.topics = topics; //Bind to view
							if(this.topics !== undefined) {
								this.totalCount = this.topics.length;
								this.pageCount = Math.ceil(this.totalCount / this.pageSize);
								callback();
								this.setPageVisible();
							}
					},
					err => {
					    console.log(err);
					});
		}    
	}

	submitTopic(){
		let commentOperation:Observable<Topic[]>;
		if (this.model.value == "" )
		{
			return;
		}

		this.model.email = this.theUser;
		this.topicService.addTopic(this.model).subscribe(
					() => {
						this.model = new Topic('', '', '');
						this.setFirstPage();
					}, 
					err => {
						console.log(err);
					});
	}

	updateTopic(topic: Topic){
		let commentOperation:Observable<Topic[]>;
		this.topicService.updateTopic(topic).subscribe(
				() => {
					this.model = new Topic('', '', '');
					this.setFirstPage();
				}, 
				err => {
					console.log(err);
				});
	}

	addUserToTopic(user: string){
     var id = this.model.users.indexOf(user);
     if (id >= 0) {
       return;
     }
  this.model.users.push(user);
		let commentOperation:Observable<Topic[]>;
		this.topicService.updateTopic(this.model).subscribe(
				() => {
				}, 
				err => {
					console.log(err);
				});
	}

	removeUserFromTopic(user: string){
     var id = this.model.users.indexOf(user);
     this.model.users.splice(id,  1);
		let commentOperation:Observable<Topic[]>;
		this.topicService.updateTopic(this.model).subscribe(
				() => {
				}, 
				err => {
					console.log(err);
				});
	}

	removeUserFromTopic2(model: Topic, user: string){
     var id = model.users.indexOf(user);
     model.users.splice(id,  1);
		let commentOperation:Observable<Topic[]>;
		this.topicService.updateTopic(model).subscribe(
				() => {
				}, 
				err => {
					console.log(err);
				});
	}


	branchTopic(topic: Topic){
    this.model.value = topic.value;
    this.model.hashTag = topic.hashTag+"-"+this.theUser;
    this.submitTopic();

    topic.topics.push(this.model.hashTag);
    this.updateTopic(topic);
  }

	deleteTopic(topic){
		let commentOperation:Observable<Topic[]>;
		if(confirm("Are you sure to delete this selected item from '#" + topic.hashTopic + "'?")) {
			this.topicService.deleteTopic(topic.ID).subscribe(
					() => {
						this.model = new Topic('', '', '');
						this.setFirstPage();
					},
					err => {
					    	console.log(err);
					});
		}
	    }

	public selectTopic( topic: any, i: number) {
		topic.rank = i + 1;
		this.selectedIndex = i;
		this.selectedTopic =  topic; 
		this.setMessage(this.selectedTopic);
	}

	public setMessage(topic: any) {
		//this.message = " { \"rank\" : \"" + topic.rank + "\", \"loc\" : { \"x\" : \"" + topic.loc.x + "\", \"y\" : \"" + topic.loc.y + "\" }, \"topic\" : \"" + topic.hashTag + "\", \"value\" : \"" + topic.value + "\", \"timestamp\" : \""+topic.insertDate +"\" } "; 
		this.message = " { \"rank\" : \"" + topic.rank + "\", \"loc\" : { \"x\" : \"47.60\", \"y\" : \"122.33\" }, \"topic\" : \"" + topic.hashtopic + "\", \"value\" : \"" + topic.value + "\", \"timestamp\" : \""+topic.insertDate +"\" } "; 
	}

	keyDown(event: any) {
		switch (event.keyCode) {
			case 38: 
				this.onUp();
				event.preventDefault();
				break;
			case 40:
				this.onDown()
				event.preventDefault();
				break;
			case 13:
				this.setFirstPage()
				event.preventDefault();
				break;
		}
		return;
	}

	public onDown() {
		if(this.selectedIndex < this.topics.length - 1)
		{
			this.selectedTopic = this.topics[++this.selectedIndex];
			this.setMessage(this.selectedTopic);
		}
	}

	public onUp() {
		if(this.selectedIndex > 0)
		{
			this.selectedTopic = this.topics[--this.selectedIndex];
			this.setMessage(this.selectedTopic);
		}
	}

	substringOf(source: string) {
		var i1 = source.indexOf( "https://" );
		var si = 8;
		if (i1 < 0)
		{
			i1 =  source.indexOf( "http://" );
			si = 7;
		}

		if(i1 >= 0)
		{
			var i2 = source.indexOf(  "/", i1 + si );
			if(i2 > 0)
			{
				var s = source.substring(i1 + si, i2);
				return s;
			}	
		}
		return source;
	}

	docTopic(topic: any) {
   this.router.navigate(['/admin/doc'],  { queryParams: { h : topic.hashTag}});
  }

	tagndoc() {
  this.router.navigate(['/admin/tagndoc']);
  }

	editTopic(topic: any) {
		//this.umodel.edit =  !this.umodel.edit;
		this.umodel = new Topic(topic.hashTag, topic.value, topic.userId);
		topic.edit = !topic.edit;
	}

	cancelUpdate(topic: Topic) {
		topic.hashTag = this.umodel.hashTag;
		topic.value = this.umodel.value;
		topic.insertDate = this.umodel.insertDate;
		topic.edit = false;
	}

	//pagination for table
	setFirstPage() {
		this.pageDirection = 0;
		this.loadTopics(() => {
			this.currentPage = 1;
		});
	}

	setPreviousPage() {
		this.pageDirection = 1;
		    this.loadTopics(() => {
			if (this.currentPage > 1) {
			    this.currentPage--;
			}
		 });
	}

	setNextPage() {
		this.pageDirection = 2;
		this.loadTopics(() => {
		    if (this.currentPage < this.pageCount) {
			this.currentPage++;
		    }
		});
	}

	setLastPage () {
		this.pageDirection = 3;
		this.loadTopics( () => {
			this.currentPage = this.pageCount;
		});
	}

	setPageVisible() {
		this.selectedIndex = (this.currentPage - 1) * this.pageSize;
		var end = this.currentPage * this.pageSize
		for (let i = 0; i < this.topics.length; i++) {
			this.topics[i].show = false;
			if(i >= this.selectedIndex && i < end) {
				this.topics[i].show = true;
			} 
		}
		this.selectedTopic = this.topics[this.selectedIndex];
		if (this.selectedTopic) {
			this.selectedTopic.rank = this.selectedIndex + 1;
			this.setMessage(this.selectedTopic);
		}
	}

	setMe(element) {
		var s_height = element.scrollHeight;
		element.setAttribute('style','height:'+s_height+'px');
	}

	selectAllTopics() {
		for (let i = 0; i < this.topics.length; i++) {
			if(!this.selectAll) {
	                        this.topics[i].checked = true;
			}
			else {
	                        this.topics[i].checked = false;
			}

                }
	}

	search() {
//		if(this.loggedInUser === undefined) {
			 this.setFirstPage();
//		} else {
//			this.router.navigate(['admin']);
//		}
			
	}

  share() {
        this.userSVC.notify(this.model);
  }

   editDoc() {
      this.router.navigate(['/admin/doc'],  { queryParams: { h : this.model.hashTag}});
    }

   goToTopics() {
      this.router.navigate(['/admin/share'],  {queryParams: {h : this.model.hashTag}});
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/user/user.component.ts